import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import { GetResponse } from "@/api/coupon-bg-image/response";
import * as CouponBgImageAPI from "@/api/coupon-bg-image";
import { isSuccess } from "@/api/response";
import { GetRequest } from "@/api/coupon-bg-image/request";

const MODULE_NAME = "coupon-bg-image/get";

/**
 * クーポン背景画像取得API（/get-coupon-bg-image）のレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Get extends VuexModule {
  // state
  getResponse: GetResponse = {} as GetResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.getResponse);
  }

  get getMessage() {
    return this.getResponse.message;
  }

  get getImage() {
    if (this.getResponse.results) {
      return this.getResponse.results.image;
    } else {
      return null;
    }
  }

  // MutationActions
  @MutationAction
  async get(request: GetRequest) {
    const getResponse = await CouponBgImageAPI.get(request);
    return {
      getResponse
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      getResponse: {} as GetResponse
    };
  }
}

export default getModule(Get);
